import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
export default class Offsetting extends Fragment {
    constructor() {
        super();
        this.code = "O";
    }

    summarize(summaryContext) {
        const message = "Offsetting,";
        return new FragmentSummary(message);
    }
}
